<template>
  <Tooltip :disabled="Boolean(data?.email) && !disabled" placement="bottom-end">
    <template #trigger>
      <StyledButton
        class="add-ingredient"
        left-icon="phone_android"
        :disabled="disabled || !data?.email"
        @click="handleClick"
      >
        Udostępnij
      </StyledButton>
    </template>
    <template v-if="disabled && disabledTooltip">{{ disabledTooltip }} </template>
    <template v-else>
      Aby udostępnić jadłospis w aplikacji, uzupełnij email w Ustawieniach pacjenta
    </template>
  </Tooltip>
</template>

<script lang="ts" setup>
  import { useQuery } from '@tanstack/vue-query'

  import { StyledButton } from '@/components/StyledButton'
  import { Tooltip } from '@/components/ui'
  import { api } from '@/services/apiService'

  type PatientDetails = {
    birth_date: number
    birth_date_not_known?: boolean
    email: string
    first_name: string
    gender: number
    last_name: string
    phone: string
  }

  const props = withDefaults(
    defineProps<{
      patientId?: number
      disabled?: boolean
      disabledTooltip?: string
    }>(),
    {
      disabled: false,
    },
  )
  const emit = defineEmits(['click'])
  const handleClick = () => {
    emit('click')
  }

  const { data } = useQuery({
    enabled: () => !!props.patientId,
    queryFn: () => api.get<PatientDetails>(`/dietitian/patient/${props.patientId}/`),
    queryKey: ['patient', () => props.patientId],
    select: response => response.data,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
</script>
